import React from "react";
import Navbar from "../../../components/Navbar";
import BackToTop from "../../../components/BackToTop";
import { Container, NavbarGroup, Content } from "../style";

const TermoCienciaChina = () => {
  return (
    <Container>
      <Container id="back-to-top-anchor" />
      <Navbar />

      <NavbarGroup aria-label="Conteúdo da página">
        <p>Índice</p>

        <ul>
          <li>
            <a href="#1">
              <span>
                <strong>1.</strong> Estrutura da Entrega
              </span>
            </a>
          </li>

          <li>
            <a href="#2">
              <span>
                <strong>2.</strong> Ciência do Cliente
              </span>
            </a>
          </li>

          <li>
            <a href="#3">
              <span>
                <strong>3.</strong> Aceite
              </span>
            </a>
          </li>
        </ul>
      </NavbarGroup>

      <Content>
        <h1 style={{ marginTop: 50 }}>China Experience 2026/2027 – Termo de Ciência</h1>

        <p>Entrega em duas etapas.</p>

        <p>
          Este documento tem como objetivo formalizar a ciência do cliente contratante quanto ao
          formato de entrega do programa CHINA EXPERIENCE 2026/2027, o qual é realizado em dois
          momentos distintos, conforme detalhado abaixo.
        </p>

        <p id="1">
          <strong>1. ESTRUTURA DA ENTREGA:</strong>
        </p>
        <p>
          1.1. O programa contratado é composto por entregáveis distribuídos em duas etapas
          complementares, cada uma correspondente a 30% (trinta por cento) e 70% (setenta por
          cento) do valor total do contrato/proposta:
        </p>

        <p>
          <strong>
            1.2. Etapa 1 — Preparação (30%) | Entrega até 10 de dezembro/2026 – Kick-off
          </strong>
        </p>
        <p>
          1.2.1. Contempla os itens preparatórios disponibilizados antes da viagem, com entrega
          prevista para dezembro/2026:
        </p>
        <ul>
          <li>Diagnóstico individual</li>
          <li>Trilha preparatória</li>
          <li>Workshops exclusivos — Online</li>
          <li>Networking estruturado — WhatsApp</li>
          <li>Plataforma de conteúdo disponibilizada imediatamente</li>
        </ul>

        <p>
          <strong>1.3. Etapa 2 — Imersão (70%) | Imersão presencial na China</strong>
        </p>
        <p>
          1.3.1. Contempla a experiência presencial e os entregáveis consolidados ao término da
          imersão internacional:
        </p>
        <ul>
          <li>
            Programação completa da imersão em 3 cidades (Pequim, Hangzhou e Shanghai), com +35h
            de conteúdo curado pela <strong>StartSe</strong>
          </li>
          <li>Sessões com speakers internacionais, visitas técnicas e wrap-up diário facilitado</li>
          <li>
            Traslados internos e tradução simultânea para o português durante toda a semana
          </li>
          <li>Visit Notes — resumo e principais insights de cada visita</li>
          <li>
            Relatório de Visitas e Insights, documento estruturado entregue ao final do programa
          </li>
          <li>
            Certificado de Conclusão <strong>StartSe</strong>
          </li>
        </ul>

        <p id="2">
          <strong>2. CIÊNCIA DO CLIENTE:</strong>
        </p>
        <p>2.1. Ao aceitar este termo, o cliente declara estar ciente de que:</p>
        <ul>
          <li>
            A entrega do programa ocorre em dois momentos distintos: (i) dezembro/2026, referente
            à Etapa 1 — Preparação; e (ii) ao término da imersão internacional na China,
            referente à Etapa 2 — Imersão;
          </li>
          <li>
            Cada etapa corresponde a 30% e 70% totalizando o contratado, sendo esse percentual
            utilizado como referência para o reconhecimento da entrega do serviço ao longo do
            tempo;
          </li>
          <li>
            Os itens não inclusos no programa (passagens aéreas internacionais, hospedagem, visto
            e seguro viagem) permanecem sob responsabilidade do participante, conforme condições
            gerais do programa.
          </li>
        </ul>

        <p id="3">
          <strong>3. ACEITE:</strong>
        </p>
        <p>3.1. Declaro estar ciente e de acordo com o formato de entrega descrito neste termo.</p>
      </Content>
      <BackToTop />
    </Container>
  );
};

export default TermoCienciaChina;
